import { render, staticRenderFns } from "./AvailabilityPanel.vue?vue&type=template&id=0abb5459&scoped=true"
import script from "./AvailabilityPanel.vue?vue&type=script&lang=ts"
export * from "./AvailabilityPanel.vue?vue&type=script&lang=ts"
import style0 from "./AvailabilityPanel.vue?vue&type=style&index=0&id=0abb5459&prod&scoped=true&lang=css"
import style1 from "@/components/acquisitionList/ui/itemDetails.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb5459",
  null
  
)

export default component.exports